import { useFeatureFlag } from "@/contexts/FeatureFlagContext"
import { NotesSection } from "../../shared/notes/NotesSection"

/** Internal notes on one inquiry, any time and also after it closed. */
export function InquiryNotesSection({ inquiryId }: { inquiryId: string }) {
  const enabled = useFeatureFlag("MC_NOTES")
  if (!enabled) return null
  return <NotesSection entityType="inquiry" entityId={inquiryId} />
}
